/**
 * Fondation feature flag gating everything that restricts a teacher by their availability
 * (#1036): the working frame and absences (Fondation Core.Availability, edited on the teacher
 * record), the competence offerings (#923, Planification › Disponibilités par compétence), the
 * « Non disponible » pills of the pickers, the availability card and view of the annual load, and
 * the six `/api/Teachers/{id}/…` availability routes. Toggled by an administrator at
 * `/core/features`; the declaration lives in
 * `backend/Parcours.Core/Features/TeacherAvailabilityFeature.cs`, and this key must match its
 * `KEY` exactly — a key the catalog does not know reads as `false`, which HIDES the feature.
 *
 * Declared `DefaultEnabled = false` on the backend: a centre that keeps no availability per
 * teacher must see every teacher available always, with no empty declaration screen. Read
 * through `useSdk().Features.isEnabled(...)`, which is reactive — the value flips once the
 * boot-time flag load resolves, so a view must react to it rather than sample it once at setup.
 *
 * The permissions still apply on top: the feature says whether availability exists on this
 * deployment, the permissions say who may read or edit it.
 */
export const TEACHER_AVAILABILITY_FEATURE = 'TeacherAvailability';
